import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';

declare const $: any;

@Component({
  selector: 'sx-tree-view',
  templateUrl: 'treeView.component.html'
})
export class TreeViewComponent implements OnInit {
  @Input('fuente') fuente: Promise<any>;
  private _data: any;
  private _selectedNodes: String[] = [];
  @Input() set selectedNodes(value: String[]) {
    this._selectedNodes = value;
  }
  @Input() set data(value: any) {
    this._data = value;
    this.inicializarTree(this._data);
  }
  @Input() includeParentsOnGetSelectedNodes: boolean = false
  @Input() propagateCheckEventToParents: boolean = true
  get data(): any {
    return this._data;
  }
  @Input() loadOnDemand: boolean = false
  @Output() notifyNodeExpanded: EventEmitter<any> = new EventEmitter<any>();
  @Output() notifyNodeChecked: EventEmitter<any> = new EventEmitter<any>();
  @Output() notifyNodeUnchecked: EventEmitter<any> = new EventEmitter<any>();
  @Output() notifyNodeRendered: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
    if (this.fuente) {
      this.fuente
        .then(data => this.inicializarTree(data.config));
      return;
    }

    if (this.data) {
      this.inicializarTree(this.data);
    }
  }

  checkAll() {
    $('#tree').treeview('checkAll', { silent: true });
  };

  uncheckAll() {
    $('#tree').treeview('uncheckAll', { silent: true });
  };

  expandAll() {
    $('#tree').treeview('collapseAll', { silent: true });
    $('#tree').treeview('expandAll', { silent: true });
  };

  collapseAll() {
    $('#tree').treeview('collapseAll', { silent: true });
  };

  search(term: String) {
    $('#tree').treeview('search', [
      term, {
        ignoreCase: true,     // case insensitive
        exactMatch: false,    // like or equals
        revealResults: true,  // reveal matching nodes
      }
    ])
  }

  clearSearch() {
    $('#tree').treeview('clearSearch');
  }

  getSelected() {
    return this.getChekedKeys();
  };

  getParents(arrKeys: any[], node: any) {
    var parents = $('#tree').treeview('getParents', node);
    if (parents.length > 0) {
      if (_.indexOf(arrKeys, parents[0].key) == -1) {
        arrKeys.push(parents[0].key)
      }
      this.getParents(arrKeys, parents[0])
    } else {
      return arrKeys
    }
  }

  checkNodes(nodes: any) {
    $('#tree').treeview('checkNode', [ nodes, { silent: true } ]);
  }
  partiallyCheckNode(node: any) {
    $('#tree').treeview('partiallyCheckNode', [ node, { silent: true } ]);
  }

  uncheckNode(node) {
    $('#tree').treeview('uncheckNode', [ node, { silent: true } ]);
  }

  private getChekedKeys() {
    let self = this;
    const arrKeys = [];
    const checkableNodes = $('#tree').treeview('getChecked');
    for (let iPos = 0; iPos < checkableNodes.length; iPos++) {
      const node = checkableNodes[iPos];
      if ((node.key !== undefined) && (!node.key.loaded || node.key.TableName !== 'SX_NOTABLENAME')) {
        // For each node selected (headers excluded), search for their parents
        node.key.state = node.state
        arrKeys.push(node.key);
        if (self.includeParentsOnGetSelectedNodes && !node.isHeader) {
          this.getParents(arrKeys, node)
        }

      }
    }
    return arrKeys;
  }

  private inicializarTree(data) {
    let self = this;
    $('#tree').treeview({
      data: data,
      expandIcon: 'fa fa-chevron-right',
      collapseIcon: 'fa fa-chevron-down',
      checkedIcon: 'far fa-check-square',
      partiallyCheckedIcon: 'fa fa-square',
      uncheckedIcon: 'far fa-square',
      loadingIcon: 'fa fa-spinner fa-spin',
      showIcon: false,
      showCheckbox: true,
      showTags: true,
      highlightSelected: false,
      highlightSearchResults: false,
      hierarchicalCheck: true,
      propagateCheckEvent: true,
      propagateCheckEventToParents: self.propagateCheckEventToParents,
      onNodeChecked: (event, node) => {
        this.notifyNodeChecked.emit(node);
      },
      onNodeUnchecked: (event, node) => {
        this.notifyNodeUnchecked.emit(node);
      },
      onNodeRendered: (event, node) => {
        this.notifyNodeRendered.emit(node);
      },
      lazyLoad: function(node, display) {
        if (self.loadOnDemand) {
          self.notifyNodeExpanded.emit({
            key: node.key,
            checked: node.state.checked,
            append: display
          })
          node.key.loaded = true
        }
      }
    });
  }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/treeView/treeView.component.ts